import "./footer.css";
import { Footer } from './footer';
export default Footer;